import React, { useEffect, useRef, useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import BackButton from '../BackButton';
import './AnswerPDFDownload.css';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// Skeleton Loader Component
const SkeletonLoader = () => (
  <div className="answer-skeleton-container">
    <div className="answer-skeleton-header"></div>
    <div className="answer-skeleton-stats">
      {Array.from({ length: 4 }).map((_, idx) => (
        <div key={idx} className="answer-skeleton-card"></div>
      ))}
    </div>
    <div className="answer-skeleton-questions">
      {Array.from({ length: 3 }).map((_, idx) => (
        <div key={idx} className="answer-skeleton-question"></div>
      ))}
    </div>
  </div>
);

// Empty State Component
const EmptyState = () => (
  <div className="answer-empty-state">
    <div className="answer-empty-icon">📝</div>
    <h3 className="answer-empty-title">No Answer Data Available</h3>
    <p className="answer-empty-message">
      Unable to load answer data for this test attempt.
      <br />
      Please check if the test was submitted properly.
    </p>
  </div>
);


const formatDateTime = (dateString) => {
  const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };
  return new Date(dateString).toLocaleDateString('en-GB', options);
};

const AnswerPDFDisplay = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  // const location = useLocation();
  // const { attemptId, testId } = location.state || {};
  const attemptId = queryParams.get("attemptId");
  const testId = queryParams.get("testId");
  const [answerData, setAnswerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const contentRef = useRef(null);  // Ref for printing
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [downloadingPDF, setDownloadingPDF] = useState(false);


  const link = process.env.REACT_APP_PANEL_BASE_URL

  const buildAnswerReportFilename = () => {
    const sanitizePart = (value) =>
      String(value ?? '')
        .trim()
        .replace(/[<>:\"/\\|?*\x00-\x1F]+/g, ' ')
        .replace(/\s+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '');

    const studentName = sanitizePart(
      [answerData?.user?.first_name, answerData?.user?.last_name].filter(Boolean).join(' ')
    ) || 'Student';

    const examDateSource = answerData?.submitted_date || answerData?.submitted_at || '';
    let examDate = 'Exam_Date';

    if (examDateSource) {
      const parsedDate = new Date(examDateSource);
      if (!Number.isNaN(parsedDate.getTime())) {
        examDate = parsedDate.toISOString().slice(0, 10);
      } else {
        const rawDatePart = String(examDateSource).split(/[T ]/)[0];
        examDate = sanitizePart(rawDatePart) || 'Exam_Date';
      }
    }

    return `${studentName}_${examDate}_Answer_Report.pdf`;
  };

  // Show button when user scrolls down
useEffect(() => {
  const handleScroll = () => {
    setShowScrollButton(window.scrollY > 300);
  };
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

// Scroll to top function
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

  useEffect(() => {
    if (attemptId && testId) {
      axiosInstance
        .get(`reports/answers/?user_id=${attemptId}&test_id=${testId}`)
        .then((response) => {
          setAnswerData(response.data?.data);
          setLoading(false);
        })
        .catch((error) => {
          setError('Failed to load answer data. Please try again.');
          setLoading(false);
        });
    }
  }, [attemptId, testId]);

  // const handleDownloadPDF = async () => {
  //   const originalElement = contentRef.current;
  
  //   if (!originalElement) {
  //     Swal.fire("Error", "Content not found", "error");
  //     return;
  //   }
  
  //   setDownloadingPDF(true);
  
  //   // 1. Clone the entire content to avoid touching the visible DOM
  //   const clone = originalElement.cloneNode(true);
  
  //   // 2. Remove all images from clone
  //   const images = clone.querySelectorAll('img');
  //   images.forEach((img) => img.remove());
  
  //   // 3. Append clone off-screen
  //   clone.style.position = 'absolute';
  //   clone.style.left = '-9999px';
  //   document.body.appendChild(clone);
  
  //   try {
  //     const canvas = await html2canvas(clone, {
  //       useCORS: false,         // No need to load external images
  //       allowTaint: false,
  //       scrollX: 0,
  //       scrollY: 0,
  //       scale: 2,
  //     });
  
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF('p', 'pt', 'a4');
  
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();
  
  //     const imgWidth = canvas.width;
  //     const imgHeight = canvas.height;
  
  //     const ratio = pdfWidth / imgWidth;
  //     const scaledHeight = imgHeight * ratio;
  
  //     let position = 0;
  
  //     while (position < scaledHeight) {
  //       const pageCanvas = document.createElement('canvas');
  //       const context = pageCanvas.getContext('2d');
  //       const pageHeightPx = pdfHeight / ratio;
  
  //       pageCanvas.width = imgWidth;
  //       pageCanvas.height = pageHeightPx;
  
  //       context.drawImage(
  //         canvas,
  //         0,
  //         position / ratio,
  //         imgWidth,
  //         pageHeightPx,
  //         0,
  //         0,
  //         imgWidth,
  //         pageHeightPx
  //       );
  
  //       const pageImgData = pageCanvas.toDataURL('image/png');
  
  //       if (position === 0) {
  //         pdf.addImage(pageImgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //       } else {
  //         pdf.addPage();
  //         pdf.addImage(pageImgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //       }
  
  //       position += pdfHeight;
  //     }
  
  //     pdf.save(`Test_Response_${answerData.test?.name || 'Report'}.pdf`);
  //   } catch (err) {
  //     console.error('PDF Generation Error:', err);
  //     Swal.fire("Error", "PDF generation failed. Try again.", "error");
  //   } finally {
  //     document.body.removeChild(clone);
  //     setDownloadingPDF(false);
  //   }
  // };
  
  const handleDownloadPDF = async () => {
    if (loading || !contentRef.current) {
      Swal.fire("Please wait", "Content is still loading...", "info");
      return;
    }
  
    setDownloadingPDF(true);
  
    try {
      const response = await axiosInstance.get("reports/answers/", {
        params: {
          test_id: testId,
          user_id: attemptId,
          type: "file",
        },
        responseType: "blob",
      });
  
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = buildAnswerReportFilename();
      document.body.appendChild(a);
      a.click();
      a.remove();
  
      Swal.fire("Download Complete", "Your report has been downloaded.", "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        "An error occurred while downloading the PDF.";
      Swal.fire("Download Failed", errorMessage, "error");
    } finally {
      setDownloadingPDF(false);
    }
  };
  

  if (loading) {
    return (
      <div className="answer-page-container">
        <SkeletonLoader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="answer-page-container">
        <div className="answer-error-state">
          <div className="answer-error-icon">⚠️</div>
          <h3 className="answer-error-title">Error Loading Data</h3>
          <p className="answer-error-message">{error}</p>
        </div>
      </div>
    );
  }

  if (!answerData || Object.keys(answerData).length === 0) {
    return (
      <div className="answer-page-container">
        <EmptyState />
      </div>
    );
  }


  return (
    <div className="answer-page-container">
      <div className="answer-content-wrapper" ref={contentRef}>
        {/* Header */}
        <div className="answer-page-header">
          <div className="answer-page-header-left">
            <BackButton />
            <div>
              <h1 className="answer-page-title">
                {answerData.submitted_date} Online MCQ Test
              </h1>
              <p className="answer-page-subtitle">{answerData.test?.name}</p>
            </div>
          </div>
          <div className="answer-user-greeting">
            Hey, {answerData.user?.first_name} {answerData.user?.last_name} 👋
          </div>
        </div>

        {/* Email and Download Section */}
        <div className="answer-top-section">
          <div className="answer-email-card">
            <span className="answer-email-label">Email:</span>
            <span className="answer-email-value">{answerData.user?.email}</span>
          </div>
          
          <button 
            className='answer-download-btn' 
            onClick={handleDownloadPDF} 
            disabled={downloadingPDF}
          >
            {downloadingPDF ? (
              <span>⏳ Downloading... (may take time)</span>
            ) : (
              <span>📥 Download Assessment Report</span>
            )}
          </button>
        </div>

        {/* Stats Cards */}
        <div className="answer-stats-section">
          <div className='answer-stat-card answer-stat-card-blue'>
            <p className='answer-stat-label'>Points Scored</p>
            <p className='answer-stat-value'>{answerData.points_scored}/{answerData.total_marks}</p>
          </div>

          <div className='answer-stat-card answer-stat-card-green'>
            <p className='answer-stat-label'>Correctly Answered</p>
            <p className='answer-stat-value'>{answerData.correctly_answered}/{answerData.total_questions}</p>
          </div>

          <div className='answer-stat-card answer-stat-card-orange'>
            <p className='answer-stat-label'>Submitted At</p>
            <p className='answer-stat-value'>{formatDateTime(answerData.submitted_at)}</p>
          </div>

          <div className='answer-stat-card answer-stat-card-purple'>
            <p className='answer-stat-label'>Time Taken</p>
            <p className='answer-stat-value'>{answerData.time_taken}</p>
          </div>
        </div>

        {/* Answer Cards Show */}
        <div className="answer-segments-container">
          {answerData.segments.map((segment, index) => (
            <div key={index} className="answer-segment-card">
              <h3 className='answer-segment-title'>{segment.name}</h3>
              
              {segment.questions.map((question, qIndex) => {
                // Check if any option was selected
                const isAnyOptionSelected = question.options.some((option) => option.is_selected);
                const isSelectedCorrect = question.options.some((option) => option.is_selected && option.is_correct);
                const isSelectedWrong = question.options.some((option) => option.is_selected && !option.is_correct);
                
                let statusMessage = "";
                let statusClass = "";
                if (question.user_answer_status === "skipped") {
                  statusMessage = "⏭ Skipped";
                  statusClass = "status-skipped";
                } else if (question.user_answer_status === "review") {
                  statusMessage = "🔄 Marked for Review";
                  statusClass = "status-review";
                } else {
                  if (question.question_type === "subjective") {
                    if (!question.user_answer || question.user_answer.trim() === "") {
                      statusMessage = "❌ Not Attempted";
                      statusClass = "status-not-attempted";
                    }
                  } else {
                    if (!isAnyOptionSelected) {
                      statusMessage = "❌ Not Attempted";
                      statusClass = "status-not-attempted";
                    }
                  }
                }

                return (
                  <div
                    key={qIndex}
                    className={`answer-question-card ${
                      isSelectedCorrect
                        ? "answer-question-correct"
                        : isSelectedWrong
                        ? "answer-question-wrong"
                        : "answer-question-neutral"
                    }`}
                  >
                    <div className='answer-question-header'>
                      <span className='answer-question-number'>Question {qIndex + 1}</span>
                      {statusMessage && (
                        <span className={`answer-status-badge ${statusClass}`}>
                          {statusMessage}
                        </span>
                      )}
                    </div>

                    <div className='answer-question-text'>
                      {question.text && <p>{question.text}</p>}
                      {question.image && (
                        <div className="answer-question-image-container">
                          <img
                            src={question.image}
                            alt="question"
                            className="answer-question-image"
                          />
                        </div>
                      )}
                    </div>

                    <ul className="answer-options-list">
                      {question.options.map((option, oIndex) => {
                        let optionClass = "answer-option-item";
                        let icon = null;

                        if (option.is_correct) {
                          optionClass += " answer-option-correct";
                          icon = <FaCheckCircle className="answer-option-icon icon-correct" />;
                        }
                        if (option.is_selected && !option.is_correct) {
                          optionClass += " answer-option-incorrect";
                          icon = <FaTimesCircle className="answer-option-icon icon-incorrect" />;
                        }

                        return (
                          <li key={oIndex} className={optionClass}>
                            <div className="answer-option-content">
                              {icon && <span className="answer-option-icon-wrapper">{icon}</span>}
                              <div className="answer-option-text-container">
                                {option.text && <span className="answer-option-text">{option.text}</span>}
                                {option.image && (
                                  <img
                                    src={option.image}
                                    alt="option"
                                    className="answer-option-image"
                                  />
                                )}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>

                    {question.question_type === "subjective" && question.user_answer && (
                      <div className="answer-subjective-response">
                        <strong className="answer-subjective-label">Answer:</strong>
                        <p className="answer-subjective-text">{question.user_answer}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* Scroll to Top Button */}
      {showScrollButton && (
        <button className="answer-scroll-top-btn" onClick={scrollToTop}>
          ⬆ Back to Top
        </button>
      )}
    </div>
  );
};

export default AnswerPDFDisplay;